import { Phone, Sparkles, CalendarCheck, PartyPopper } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Phone,
    title: "Inquire",
    body: "Submit the inquiry form or email Cherisse. You'll hear back within 1 business day — no chasing, no gatekeepers.",
    time: "1 business day",
    href: "#book",
  },
  {
    n: "02",
    icon: Sparkles,
    title: "Discovery Call",
    body: "30-minute call with Gary's team to understand your practice, referral partners, and what success looks like for the night.",
    time: "30 minutes",
    href: "#book",
  },
  {
    n: "03",
    icon: CalendarCheck,
    title: "Custom Event Plan",
    body: "Gary builds the experience around your audience — venue flow, recognition moments, custom content for your team and partners.",
    time: "Done-for-you",
    href: "#book",
  },
  {
    n: "04",
    icon: PartyPopper,
    title: "Standing Ovation Night",
    body: "Gary shows up. Your partners feel celebrated. Your team feels seen. Guests leave saying, 'That was one of the best events we've ever attended.'",
    time: "The big night",
    href: "#book",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">HOW IT WORKS · 4 STEPS</span>
          <div className="divider-red" />
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <h2 className="h-display text-5xl md:text-6xl lg:text-7xl max-w-3xl">
            From inquiry to <br />
            <span className="text-[#EC1985]">standing ovation.</span>
          </h2>
          <p className="text-white/70 text-lg max-w-md">
            No long sales process. No 50-page proposals. Just a clear path from
            "we want to do this" to a night your practice talks about for years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <a
                key={s.n}
                href={s.href}
                data-testid={`step-${i}`}
                className="relative surface p-7 hover:border-[#EC1985] transition-colors group block no-underline"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="font-display text-5xl text-[#EC1985] leading-none">
                    {s.n}
                  </div>
                  <Icon size={26} className="text-white/40 group-hover:text-white transition-colors" />
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-white/50 font-bold mb-2">
                  {s.time}
                </div>
                <h3 className="font-display text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{s.body}</p>

                {i === 0 && (
                  <div className="mt-4 text-xs uppercase tracking-[0.15em] font-bold text-[#EC1985]">
                    Click → Opens inquiry form
                  </div>
                )}

                {/* Arrow connector for desktop */}
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 -translate-y-1/2 text-[#262626] group-hover:text-[#EC1985] transition-colors text-2xl z-10">
                    →
                  </div>
                )}
              </a>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <a href="#book" data-testid="how-it-works-cta" className="btn-primary">
            Start Step 1 — Submit Your Inquiry
          </a>
          <div className="mt-4 text-xs uppercase tracking-[0.2em] text-white/50 font-bold">
            ✓ 1 Business Day Response · ✓ No Pressure · ✓ Real Humans
          </div>
        </div>
      </div>
    </section>
  );
}
